module.exports = __webpack_public_path__ + "img/video-cover.2759caee.jpg";